import React from 'react';

import { useRouteError } from 'react-router-dom';

export const ErrorPage = props => {
  const error = useRouteError();

  return (
    <div className='m-8'>
      <div className='py-4'>
        <p>An error has occurred</p>
      </div>
      {error ? (
        <div className='border bg-yellow-50'>
          <pre>{JSON.stringify(error)}</pre>
        </div>
      ) : (
        <div>No error details</div>
      )}
    </div>
  );
};
